import { endsWith } from 'lodash'

/**
 * Check file extension
 *
 * @param {File} file
 * @param {String} extensions
 * @return {Boolean}
 */
export const isValidExtension = (file, extensions = null) => {
  const accepted = extensions
    ? extensions.split(',').map((x) => x.toLowerCase())
    : []

  if (accepted.length) {
    return accepted.some((x) => {
      return endsWith(file.name.toLowerCase(), x)
    })
  }

  return true
}

/**
 * Check max file size
 *
 * @param {File} file
 * @param {Number|Object} maxSize
 * @return {Boolean}
 */
export const isValidSize = (file, maxSize) => {
  const compareFileSize = (size) => {
    return file.size / 1024 / 1024 <= Number.parseInt(size)
  }

  // Check file size base on extension
  if (maxSize && typeof maxSize === 'object') {
    return Object.keys(maxSize).some((ext) => {
      if (endsWith(file.name.toLowerCase(), ext)) {
        return compareFileSize(maxSize[ext])
      }

      if (ext === '*') {
        return compareFileSize(maxSize[ext])
      }

      return false
    })
  }

  if (maxSize) {
    return compareFileSize(maxSize)
  }

  // Unlimited
  return true
}

export const isValidName = (fileName) => {
  // Get fileName with no extensions
  const name = fileName.split('.').slice(0, -1).join('.')

  return /^[a-zA-Z0-9-_+\s]+$/.test(name)
}

/**
 * Validate file
 *
 * @param {Object|File} file
 * @param {Object} { accept, maxFileSize }
 * @return {Object|File}
 */
export const validateFile = (file, { accept, maxFileSize }) => {
  // Validate ext
  if (isValidExtension(file, accept) === false) {
    file.error = '! Incorrect file type'
  }

  // Validate name
  if (isValidName(file.name) === false) {
    file.error = '! Incorrect file name'
  }

  // Validate size
  if (isValidSize(file, maxFileSize) === false) {
    file.error = '! File too large'
  }

  // Set file status
  file.status = file.error ? 'error' : file.status

  return file
}
